<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128"/>
  </div>

  <!-- Modal close -->
  <div class="w-full h-screen bg-transparent absolute top-0 left-0 right-0 z-40 cursor-default" v-show="approvalModal" @click="(approvalModal = false)"></div>

  <!-- Approval Modal -->
  <vue-final-modal
    v-model="approvalModal"
    classes="base-modal"
    :ssr="true"
    :content-class="darkMode ? 'delete-modal bg-darkmode-base transition-colors duration-1000' : 'delete-modal bg-gray-100 transition-colors duration-1000'"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>Information</h1>

      <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="approvalModal = false"
      />
    </div>

    <!-- Modal content -->
    <div class="delete-content">
      <div v-if="employeetraining.state != 'Rejected'" class="warning">
        {{ $t("menu.warning") }}
      </div>
      <div v-if="employeetraining.state != 'Rejected'" class="messsage">
        <p>Are you sure?</p>
      </div>

      <!-- <field v-if="employeetraining.state == 'Rejected'" :label="$t('Reason')" class="form-col-input-full form-select">
        <textarea v-model="filter.reason" style="width: -webkit-fill-available !important height: 150px" />
      </field> -->
    </div>

    <!-- Button action -->
    <div
      class="buttons-submit transition-colors duration-1000"
      :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'"
    >
      <jb-buttons class="buttons-action-submit">
        <jb-button
          :label="$t('finance.button.btnConfirm')"
          color="info"
          @click="confirm"
          class="form-submit-btn"
        />
        <jb-button
          :label="$t('finance.button.btnCancel')"
          outline
          @click="cancel"
          class="btn-reset form-noicon-btn"
        />
      </jb-buttons>
    </div>
  </vue-final-modal>

  <div class="shadow overflow-hidden w-full max-w-4xl">
    <div>
      <dl>
        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeetraining.employee_name") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ employeetraining.employee_name }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeetraining.name") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ employeetraining.name }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeetraining.organizer") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ employeetraining.organizer }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeetraining.venue") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ employeetraining.venue }}
          </dd>
        </div>

        <div
          class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeetraining.start_date") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ employeetraining.start_date }}
          </dd>
        </div>

        <div
          class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeetraining.end_date") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ employeetraining.end_date }}
          </dd>
        </div>

        <div
          class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            External Training?
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ employeetraining.is_external ? "Yes" : "No" }}
          </dd>
        </div>

        <div
          class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeetraining.certificate_no") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ employeetraining.certificate_no }}
          </dd>
        </div>

        <div
          class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeetraining.certificate_exp_date") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ employeetraining.certificate_exp_date }}
          </dd>
        </div>

        <!-- <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeetraining.updated_at") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            <span
              class="inline-block rounded-full px-3 py-1 text-sm font-semibold bg-ora"
              :class="
                employeetraining.state == 'Approved'
                  ? 'bg-green-200 text-green-800'
                  : employeetraining.state == 'Rejected'
                  ? 'bg-red-200 text-red-800'
                  : employeetraining.state == 'Waiting for Approval'
                  ? 'bg-yellow-200 text-yellow-800'
                  : ''
              "
              >{{ employeetraining.state }}</span
            >
          </dd>
        </div> -->

        <div
          class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeetraining.created_by") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ employeetraining.created_by }}
          </dd>
        </div>

        <div
          class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeetraining.updated_by") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ employeetraining.updated_by }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeetraining.created_at") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ employeetraining.created_at }}
          </dd>
        </div>

        <div
          class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6"
        >
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t("employeetraining.updated_at") }}
          </dt>
          <dd
            class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2"
          >
            {{ employeetraining.updated_at }}
          </dd>
        </div>

        <div class="col-span-2 bg-white dark:bg-gray-700">
          <jb-buttons
            type="flex flex-col sm:flex-row justify-between p-4 bg-white-100 rounded-b-lg gap-2"
          >
            <jb-button
              v-if="employeetraining.state == 'Draft'"
              :icon="mdiSend"
              label="Send to Approver"
              color="warning"
              class="px-4 m-2 btn btn-action py-2 flex items-center w-full sm:w-auto sm:flex-1 justify-center"
              small
              @click="showApprovalModal('Waiting for Approval')"
            />
            <!-- Approve / Reject -->
            <jb-button
              v-if="employeetraining.state == 'Waiting for Approval' && checkUser"
              :icon="mdiCheckBold"
              label="Approved"
              color="success"
              class="px-4 m-2 btn btn-action py-2 flex items-center w-full sm:w-auto sm:flex-1 justify-center"
              small
              @click="showApprovalModal('Approved')"
            />
            <jb-button
              v-if="employeetraining.state == 'Waiting for Approval' && checkUser"
              :icon="mdiCancel"
              label="Reject"
              color="danger"
              class="px-4 m-2 btn btn-action py-2 flex items-center w-full sm:w-auto sm:flex-1 justify-center"
              small
              @click="showApprovalModal('Rejected')"
            />
            <!-- End -->
          </jb-buttons>
        </div>

        <div>
          <main-section>
            <employeeTrainingFile :propEmployeeTraining="employeetraining" :employeeTrainingId="employeetraining.id" />
          </main-section>
        </div>
      </dl>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { onMounted, ref, reactive, watchEffect } from "vue"
import Loading from "vue-loading-overlay"
import "vue-loading-overlay/dist/vue-loading.css"
import { mdiClose, mdiSend,mdiCheckBold, mdiCancel } from "@mdi/js"
import JbButton from "@/components/JbButton"
import JbButtons from "@/components/JbButtons"
import axios from "axios"
import { useToast } from "vue-toastification"
import { useI18n } from "vue-i18n"
import MainSection from "@/components/MainSection"
import employeeTrainingFile from '@/views/humanresource/employeetrainingfile/Index.vue'
import CryptoJS from 'crypto-js'

export default {
  name: "EmployeeTrainingDetail",
  components: {
    MainSection,
    Loading,
    JbButtons,
    JbButton,
    employeeTrainingFile
  },
  props: {
    propEmployeeTraining: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propObject: {
          type: Object,
          default: () => ({ empty: true })
    },
    propClass: {
      type: Object,
      default: () => ({ empty: true })
    }
  },
  emits: ["close-modal", "submit", "refresh-list"],
  setup(props, { emit }) {
    const titleStack = ref(["Admin", "Details"])
    const toast = useToast()
    const isLoading = ref(false)
    const { t } = useI18n()
    const EmployeeTrainingFileModal = ref(false)
    const approvalModal = ref(false)
    const deleteModal = ref(false)
    const EmployeeTrainingFileObject = ref({})
    const showEdit = ref(false)
    const detailModal = ref(false)

    const employeetraining = reactive({
      id: "",
      employee_id: "",
      employee_name: "",
      name: "",
      organizer: "",
      venue: "",
      start_date: "",
      end_date: "",
      is_external: false,
      certificate_no: "",
      certificate_exp_date: "",
      created_by: "",
      updated_by: "",
      created_at: "",
      updated_at: "",
    })

    const userlogin = localStorage.getItem("username")
    const approver_id = localStorage.getItem("user_id")

    const actionSendToApprover = async () => {
      const configHeaders = {
        "content-type": "application/json",
        Accept: "application/json",
      }
      const url = "employee-training-waiting/" + employeetraining.id
      console.log("url", url)
      const method = "PUT"
      const params = {
        updated_by: userlogin,
      }
      await axios({
        method,
        url,
        data: params,
        headers: configHeaders,
      })
        .then((response) => {
          console.log(response)
          if (response.data.success) {
            emit("close-modal")
            emit("refresh-list")
            toast.success(t(response.data.message))
          } else {
            errors.value = response.data.messages
            toast.error(t(response.data.messages))
          }
          isLoading.value = false
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 422) {
              for (var key in error.response.data) {
                toast.error(t(error.response.data[key].toString()))
              }
            } else {
              toast.error(t(error.response.data.message))
            }
          } else if (error.message) {
            console.log(error.message)
            toast.error(t(error.message))
            console.log(JSON.stringify(error.message))
          }
          isLoading.value = false
        })
    }

    const actionApprove = async () => {
      const configHeaders = {
        "content-type": "application/json",
        Accept: "application/json",
      }

      const url = "employee-training-approve/" + employeetraining.id
      console.log("url", url)
      const method = "PUT"

      const params = {
        updated_by: userlogin,
      }
      employeetraining.state = "Approved"
      await axios({
        method,
        url,
        data: params,
        headers: configHeaders,
      })
        .then((response) => {
          console.log(response)
          if (response.data.success) {
            emit("close-modal")
            emit("refresh-list")
            toast.success(t(response.data.message))
          } else {
            errors.value = response.data.messages
            toast.error(t(response.data.messages))
          }
          isLoading.value = false
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 422) {
              for (var key in error.response.data) {
                toast.error(t(error.response.data[key].toString()))
              }
            } else {
              toast.error(t(error.response.data.message))
            }
          } else if (error.message) {
            console.log(error.message)
            toast.error(t(error.message))
            console.log(JSON.stringify(error.message))
          }
          isLoading.value = false
        })
    }

    const actionReject = async () => {
      const configHeaders = {
        "content-type": "application/json",
        Accept: "application/json",
      }

      const url = "employee-training-reject/" + employeetraining.id
      console.log("url", url)
      const method = "PUT"

      const params = {
        updated_by: userlogin,
      }
      employeetraining.state = "Rejected"
      await axios({
        method,
        url,
        data: params,
        headers: configHeaders,
      })
        .then((response) => {
          console.log(response)
          if (response.data.success) {
            emit("close-modal")
            emit("refresh-list")
            toast.success(t(response.data.message))
          } else {
            errors.value = response.data.messages
            toast.error(t(response.data.messages))
          }
          isLoading.value = false
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 422) {
              for (var key in error.response.data) {
                toast.error(t(error.response.data[key].toString()))
              }
            } else {
              toast.error(t(error.response.data.message))
            }
          } else if (error.message) {
            console.log(error.message)
            toast.error(t(error.message))
            console.log(JSON.stringify(error.message))
          }
          isLoading.value = false
        })
    }

    const confirm = () => {
      if (employeeTrainingState.value == "Waiting for Approval") {
        actionSendToApprover()
        closeApprovalModal()
      } else if (employeeTrainingState.value == "Approved") {
        actionApprove()
        closeApprovalModal()
      } else if (employeeTrainingState.value == "Rejected") {
        actionReject()
        closeApprovalModal()
      }
    }

    const cancel = () => {
      if (action == "Delete") {
        deleteModal.value = false
      }
    }

    const employeeTrainingState = ref("Draft")
    
    const showApprovalModal = (state) => {
      employeeTrainingState.value = state
      approvalModal.value = true
    }

    const closeApprovalModal = () => {
      approvalModal.value = false
    }

    watchEffect(() => {
      const newEmployeeTraining = props.propEmployeeTraining
      if (newEmployeeTraining && Object.keys(newEmployeeTraining).length > 0) {
        Object.assign(employeetraining, newEmployeeTraining)
      }
    })

    const userRole = localStorage.getItem('roles')
    const checkUser = ref(false)
    const userCheck = async () => {
      if (userRole !== null) {
          const decryptedMessage = CryptoJS.AES.decrypt(localStorage.getItem('role'), 'amatra1609').toString(CryptoJS.enc.Utf8)
          const myArray = decryptedMessage.split(',')
          for (let i = 0; i < myArray.length; i++) {
              if (myArray[i] === 'ROLE_ADMIN_HRD') {
                  checkUser.value = true
              }
          }
      }
    }

    onMounted(() => {
      userCheck()
    })

    return {
      checkUser,
      titleStack,
      employeetraining,
      isLoading,
      mdiSend,
      mdiCheckBold,
      mdiCancel,
      actionSendToApprover,
      actionApprove,
      actionReject,
      approvalModal,
      showApprovalModal,
      closeApprovalModal,
      confirm,
      cancel,
      employeeTrainingState,
      deleteModal,
    }
  },
  beforeMount() {
    this.context = {
      componentParent: this,
    }
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi
      const allColumnIds = []
      this.gridColumnApi.getAllColumns().forEach((column) => {
        allColumnIds.push(column.colId)
      })
      this.gridColumnApi.autoSizeColumns(allColumnIds, false)
    },
  },
}
</script>
